import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  metricSectionContainer: {
    marginBottom: 0,
    paddingBottom: 0,
  },
  metricSectionHeader: {
    marginBottom: 4,
  },
  featureFeedback: {
    marginTop: 20,
  },
});
